import {
  Box,
  Button,
  Divider,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  Paper,
  Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { makeStyles } from "@mui/styles";
import React, { useEffect } from "react";

import { ReactComponent as TrashIcon } from "../../assets/images/portfolio/trash-alt.svg";
import { ReactComponent as CloseIcon } from "../../assets/images/plus-circle-fill.svg";
import { ReactComponent as PdfIcon } from "../../assets/images/iconFile/pdf.svg";
import { ReactComponent as JpgIcon } from "../../assets/images/iconFile/jpg.svg";
import { ReactComponent as PngIcon } from "../../assets/images/iconFile/png.svg";
import { ReactComponent as NullIcon } from "../../assets/images/iconFile/Null-File.svg";
import { ReactComponent as JpegIcon } from "../../assets/images/iconFile/jpeg.svg";
import * as Util from "../../services/global.service";

import DropZone from "../DropZone";
import fileBrowser from "../../icons/file-browser.svg";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";

import workloadAndPerformanceService from "../../services/workloadAndPerformance.service";

import {
  getConfigUpload,
  postUploadFile
} from "../../actions/achievement";


const units = ['bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
function niceBytes(x) {
  let l = 0, n = parseInt(x, 10) || 0;
  while (n >= 1024 && ++l) {
    n = n / 1024;
  }
  return (n.toFixed(n < 10 && l > 0 ? 1 : 0) + ' ' + units[l]);
}
const useStyles = makeStyles({
  btnDisabled: {
    '& .Mui-disabled': {
      color: "#FFFFFF !important",
      backgroundColor: "#BABABA !important"
    }
  },
  blockFiles: {
    cursor: "pointer"
  }
});
const AttachFilesDialog = (props) => {
  const { t, i18n } = useTranslation()
  const dispatch = useDispatch();
  const handleClose = () => {
    setFileList([])
    props.setValue(false)
    setSubmitFiles(false)
  };
  const { value } = props;
  const classes = useStyles();
  let { serial } = useParams();
  const [fileList, setFileList] = React.useState([]);
  const [fileListDe, setDeFileList] = React.useState([]);
  const [dataFile, setFile] = React.useState([]);
  const [setting, setSetting] = React.useState([{
    extension: [],
    max: 0,
    size: 0,
  }]);
  const [isSubmitFiles, setSubmitFiles] = React.useState(false);
  useEffect(() => {
    let data = []
    let sumdata = [...fileList, ...fileListDe]
    for (let index = 0; index <= dataFile.length - 1; index++) {
      let status = true
      for (let id = 0; id <= sumdata.length - 1; id++) {
        if (dataFile[index]?.name === sumdata[id]?.name) {
          status = false
        }
      }
      if (status === true && sumdata.length + data.length < setting?.max) {
        data.push(dataFile[index])
      }
    }
    setFileList([...fileList, ...data]);
  }, [dataFile]);

  const handleFilesUpload = (event, elm) => {
    if (elm === "onDrop") {
      setFile(event)
    } else {
      setFile(event.target.files)
    }
  }
  const handleRemoveFile = (val) => {
    let newFileList = [...fileList].filter(file => file !== val)
    setFileList(newFileList)
  }
  const handleSubmitFiles = (files) => {
    console.log("submit")
    setSubmitFiles(true)
    dispatch(postUploadFile(serial, files)).then((resp) => {
      props.submitFiles(files)
      handleClose()
    })
  }
  const config = () => {
    dispatch(getConfigUpload()).then((resp) => {
      setSetting(resp.data.data)
    })
  }

  useEffect(() => {
    setData()
    config()
  }, [props.value, value]);

  let setData = () => {
    if (value !== null && value !== undefined && value !== "" && value.length > 0) {
      let data = []
      for (let index = 0; index <= value.length - 1; index++) {
        data.push(value[index].file)
      }
      setDeFileList(data)
    } else if (value !== null && value !== undefined && value !== "" && value.length < 1) {
      setDeFileList([])
    }
  }

  let defectType = (data) => {
    if (data?.size > setting?.size * 1048576) {
      return false
    } else {
      for (let id = 0; id <= setting.mimetype.length - 1; id++) {
        console.log(setting.mimetype[id], data?.type, 999);
        if (setting.mimetype[id] === data?.type) {
          return true
        }
      }
      return false
    }
  }

  let defectTypeSubmit = () => {
    let check = true
    for (let index = 0; index < fileList.length; index++) {
      if (check === true) {
        if (fileList[index]?.size > setting?.size * 1048576) {
          check = false
        } else if (setting.mimetype.length > 0) {
          let data = null
          for (let id = 0; id <= setting.mimetype.length - 1; id++) {
            if (setting.mimetype[id] === fileList[index]?.type) {
              data = true
            }
          }
          if (data !== true) {
            check = false
          }
        }
      }
    }
    return check;
  }

  return (
    <React.Fragment>
      <Dialog
        open={props.open}
        onClose={handleClose}
        maxWidth="md"
        fullWidth={true}
        aria-labelledby="attach-file-dialog"
        aria-describedby="attach-file-description"
        PaperProps={{ sx: { padding: '10px' } }}
        component="div"
      >
        <DialogTitle id="form-add-dialog-title" fontSize={24} color="#404349">
          {t("achievement.label.dialog.addAttachments")}
          <Box sx={{ position: "absolute", right: 0, margin: "30px 20px 0  0", top: 0 }} className="clickable" onClick={handleClose}><CloseIcon /></Box>
        </DialogTitle>
        <DialogContent px={3} dividers={true}>
          <DialogContentText id="alert-dialog-description" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexFlow: 'column' }}>
            <Grid container>
              <Grid item md><Typography textAlign="center" mt={2} fontSize={18}>{t("achievement.label.dialog.uploadAchievementTitle")} </Typography></Grid>
            </Grid>
            <Grid container mt={3}>
              <Grid item md>
                <DropZone file={handleFilesUpload}></DropZone>
              </Grid>
            </Grid>
            <Grid container mt={1}>
              <Grid item md>
                <Typography variant="sub_label">{t("achievement.label.dialog.supportFiles")} : {setting?.extension ? setting?.extension.join(', ') : '-'}</Typography>
              </Grid>
              <Grid item md
                display="flex"
                alignItems="center"
                justifyContent="flex-end"
              >
                <Typography variant="sub_label">{t("achievement.label.dialog.fileSize")} : {setting?.size} MB</Typography>
              </Grid>
            </Grid>
            <Grid container mt={3}>
              <Grid item lg={12}>
                <Divider />
              </Grid>
            </Grid>
            <Grid container mt={3}>
              <Grid item md={6} pr={1}>
                <Typography fontWeight="500" color="#404349">
                  {t("achievement.label.dialog.fileList")}
                </Typography>
              </Grid>
            </Grid>
            {
              fileList.length > 0 ?
                [...fileList].map(item => {
                  return (
                    <Grid container mt={1}>
                      <Grid item xs={12} >
                        <Paper elevation={2}>
                          <Grid container item p={2}>
                            <Grid
                              item
                              display="flex"
                              alignItems="center"
                              md={1}
                            >
                              <Box ml={1} p={0} sx={{ width: "33px", height: "33px", maxHeight: "100%", maxWidth: "100%" }}>
                                {/* <img
                                    src={PdfIcon}
                                    alt="pdf"
                                /> */}
                                {item.type === "application/pdf" ?
                                  <PdfIcon /> :
                                  item.type === "image/png" ?
                                    <PngIcon /> :
                                    item.type === "image/jpeg" ?
                                      <JpgIcon /> : <NullIcon />
                                }
                              </Box>
                            </Grid>
                            <Grid item xs={9} pr={1}>
                              <Grid container>
                                <Grid item pr={1} sx={{ width: "100%" }}>
                                  <Typography variant="h5" color="#404349" sx={{ wordBreak: "break-all" }}>
                                    {item.name}
                                  </Typography>
                                </Grid>
                                {
                                  defectType(item) === false ?
                                    <Grid item pr={1}>
                                      <Typography variant="sub_label" color="#CC6058">
                                        {t("achievement.label.dialog.uploadFailed")}
                                      </Typography>
                                    </Grid>
                                    :
                                    <Grid item pr={1}>
                                      <Typography variant="sub_label">
                                        {niceBytes(item.size)}
                                      </Typography>
                                      <Typography variant="sub_label" pl={1} pr={1}>
                                        |
                                      </Typography>
                                      <Typography variant="sub_label">
                                        {Util.formatDate3(item.lastModifiedDate)}
                                      </Typography>
                                    </Grid>
                                }
                              </Grid>
                            </Grid>
                            <Grid
                              item
                              display="flex"
                              alignItems="center"
                              ml="auto"
                            >
                              <Box sx={{ ml: "auto" }} onClick={() => handleRemoveFile(item)} className="clickable">
                                <TrashIcon />
                              </Box>
                            </Grid>
                          </Grid>
                        </Paper>
                      </Grid>
                    </Grid>
                  )
                }
                ) : (
                  <Grid container spacing={4} mt={0}>
                    <Grid item lg={12} md={12}>
                      <Box
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        flexDirection="column"
                        p={1}
                      >
                        <Box>
                          <img src={fileBrowser} alt="browser" />
                        </Box>
                        <Box>
                          <Typography variant="sub_label">{t("label.noData")}</Typography>
                        </Box>
                      </Box>
                    </Grid>
                  </Grid>
                )
            }
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', mb: 0, mt: 1 }}>
          {/* <Button onClick={handleClose} size="large" variant="contained" sx={{width: '300px'}}>ปิด</Button> */}
          <Box>
            <Button onClick={handleClose} color="black" variant="outlined" sx={{ width: "100px", mr: 2 }}>
              <Typography fontWeight="500">{t("label.cancel")}</Typography>
            </Button>
          </Box>
          <Box className={fileList.length === 0 ? `${classes.btnDisabled}` : defectTypeSubmit() === false ? `${classes.btnDisabled}` : isSubmitFiles === true ? `${classes.btnDisabled}` : ""}>
            <Button disabled={fileList.length === 0 ? true : defectTypeSubmit() === false ? true : isSubmitFiles === true ? true : false} onClick={() => handleSubmitFiles(fileList)} color="primary" variant="contained" sx={{ width: "100px" }}>
              <Typography fontWeight="500">{t("label.add")}</Typography>
            </Button>
          </Box>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};
export default AttachFilesDialog;
